<template>
      <div class="container">
      <button
        type="button"
        class="premium-preview-btn img-container cursorclickicon"
        aria-label="Upgrade to view premium portfolio scorecard"
        @click="modalShow = !modalShow"
      >
        <img
          class="img-fluid"
          alt=""
          aria-hidden="true"
          src="https://storage.googleapis.com/mscharts/portfoliosmith/TradingAnalysis.png"
        />
      </button>

    <b-modal size="md" v-model="modalShow" hide-footer hide-header body-class="pricingPopUpModel">
      <div class="pricingPopUp">
      <img src="../../assets/img/lockscreens/premiumCard.png" alt="" aria-hidden="true">
        <div class="pricingPopUpBtn">
            <button type="button" @click="redirecttoplanpage" v-if="!isARGuest">Upgrade to view premium reports</button>
            <a class="cursorclickicon" target="_blank" href="https://storage.googleapis.com/mscharts/portfoliosmith/SamplePsiReportGeneric.pdf"> Sample Premium Report </a>
        </div>
    </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "TradingAnalysisBlurred",
  data() {
      return {
        modalShow: false
      }
    },
  computed: {
    isARGuest() {
      return localStorage.getItem('userType') == 3? true:false;
    }
  },

    methods:{

      redirecttoplanpage(){
        this.$router.push('plandetails')
      }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Report/TradingAnalysisBlurred.vue